@if (isDialog) {
    <div class="dialog-close-bar">
        <button class="dialog-close-button" (click)="close()" mat-mini-fab aria-label="Sluiten">
            <mat-icon fontSet="far" fontIcon="fa-xmark" />
        </button>
    </div>
} @else {
    <div class="dialog-close-bar d-print-none">
        <button class="dialog-print-button" (click)="window.print()" mat-mini-fab aria-label="Printen">
            <mat-icon fontSet="far" fontIcon="fa-print" />
        </button>
    </div>
}
<div class="opdrachtformulier">
    <header class="header">
        <div class="brand">
            <img class="logo" src="/assets/logo.svg" alt="Track Line markeringen" />

            <table class="company-details">
                <tbody>
                    <tr>
                        <td width="140">Handelstraat 2,</td>
                        <td>4143 HT LEERDAM</td>
                    </tr>
                    <tr>
                        <td>Postbus 107,</td>
                        <td>4140 AC LEERDAM</td>
                    </tr>
                    <tr>
                        <td>Telefoonnummer</td>
                        <td>+31 345 42 38 93</td>
                    </tr>
                    <tr>
                        <td>E-mailadres</td>
                        <td>info&#64;trackline.nl</td>
                    </tr>
                    <tr>
                        <td>Website</td>
                        <td>www.trackline.nl</td>
                    </tr>
                </tbody>
            </table>
        </div>
    </header>

    <section class="form-block form-block--title">
        <h1 class="title">OPDRACHTFORMULIER</h1>
    </section>

    <section>
        <table>
            <tbody>
                <tr>
                    <th width="170">Ploeg</th>
                    <td>{{ planning | performerOrHiringCompany }}</td>
                    <th>Werknummer</th>
                    <td>{{ planning?.afas_project_id }}</td>
                </tr>
                <tr>
                    <th>Uitgegeven door</th>
                    <td colspan="3">{{ planning?.projectmanager_user?.name }}</td>
                </tr>
                <tr>
                    <th>Werkomschrijving</th>
                    <td colspan="3">{{ planning?.project?.name }}</td>
                </tr>
            </tbody>
        </table>
    </section>

    @if (planning) {
        <section>
            <table>
                <tbody>
                    <tr>
                        <th width="170">Opdrachtgever</th>
                        <td width="30%">{{ selectedCustomerName }}</td>
                        <th width="170"></th>
                        <td width="30%"></td>
                    </tr>
                    <tr>
                        <th>Contactpersoon</th>
                        <td>
                            {{ person?.name }}
                        </td>
                        <th>Telefoon mobiel</th>
                        <td>
                            {{ person?.phone_number | phoneNumber }}
                        </td>
                    </tr>
                </tbody>
            </table>
        </section>
    }

    <section>
        <table>
            <tbody>
                <tr>
                    <th width="270">Afgesproken uitvoeringsdatum</th>
                    <td>{{ planning?.mainPlanning | dateRange: 'EEEE d MMMM yyyy HH:mm' }}</td>
                </tr>
                <tr>
                    <th width="270">Verkeersmaatregel</th>
                    <td>
                        {{ planning | planningFieldValue: 'verkeersmaatregel' }}
                        {{ planning | planningFieldValue: 'leverancier_verkeersmaatregel' : ' door ' }}
                    </td>
                </tr>

                <tr>
                    <th>Meldadres/Werklocatie</th>
                    <td>{{ planning?.location }}</td>
                </tr>
            </tbody>
        </table>
    </section>

    @if (planning?.planning_materials?.length) {
        <section class="form-block materials-block">
            <table class="materials-table">
                <thead>
                    <tr>
                        <th>Materiaal</th>
                        <th>Leverancier</th>
                        <th>Kleur</th>
                        <th>Cert.</th>
                        <th class="text-end">Dikte <small>(mm)</small></th>
                        <th class="text-end">Verbruik <small>(kg/m2)</small></th>
                        <th class="text-end">Hoeveelheid</th>
                    </tr>
                </thead>
                <tbody>
                    @for (material of planning?.planning_materials; track $index) {
                        <tr>
                            <td>{{ material.material | materialProperty: 'name' }}</td>
                            <td>{{ material.material | materialProperty: 'supplier' }}</td>
                            <td>
                                {{ material.material | materialProperty: 'colorName' }}
                                {{ material.material | materialProperty: 'colorRal' }}
                            </td>
                            <td>{{ material.material | materialProperty: 'certificate_number' }}</td>
                            <td class="text-end">{{ material.material | materialProperty: 'thickness' }}</td>
                            <td class="text-end">{{ material.material | materialProperty: 'consumption' }}</td>
                            <td class="text-end">
                                {{ material.quantity | number: '0.0-3' }}
                                {{ material.material | materialProperty: 'quantity_unit' }}
                            </td>
                        </tr>
                        @for (rawMaterial of material.material | nonMainRawMaterials; track rawMaterial.id) {
                            <tr class="others">
                                <td>
                                    {{ rawMaterial | materialProperty: 'typeName' : rawMaterial.material_type?.name }}
                                </td>
                                <td>{{ rawMaterial?.supplier?.name }}</td>
                                <td></td>
                                <td>{{ rawMaterial.certificate_number }}</td>
                                <td class="text-end">{{ rawMaterial.thickness }}</td>
                                <td class="text-end">
                                    {{ rawMaterial.pivot?.consumption ?? rawMaterial.consumption | number: '0.0-3' }}
                                    {{ rawMaterial.consumption_type?.name }}
                                </td>
                                <td class="text-end">{{ rawMaterial | rawMaterialQuantity: material }}</td>
                            </tr>
                        }
                    }
                </tbody>
            </table>
        </section>
    }
    @if (planningHasList?.length) {
        <section>
            <table>
                <thead>
                    <tr>
                        <th>Ingepland materieel</th>
                        <th>Chauffeur</th>
                        <th>Tijden</th>
                        <th>Opmerkingen</th>
                    </tr>
                </thead>
                <tbody>
                    @for (planningHas of planningHasList; track planningHas.id ?? $index) {
                        <tr>
                            <td>{{ planningHas?.entity?.name ?? planningHas.name }}</td>
                            <td>{{ planningHas.driver_user?.name ?? planningHas.driver_user_id ?? '-' }}</td>
                            <td>
                                {{ planningHas.begindate | date: 'EEE d MMM HH:mm' }} -
                                {{ planningHas.enddate | date: 'HH:mm' }}
                            </td>
                            <td [innerHTML]="planningHas.comment ?? '-' | nl2br"></td>
                        </tr>
                    }
                </tbody>
            </table>
        </section>
    }

    <section>
        <table>
            <tbody>
                <tr>
                    <th width="120">Opmeten</th>
                    <td width="30%">{{ planning | planningFieldValue: 'opmeten' }}</td>
                    <th width="130">Aantal personen</th>
                    <td width="30%">{{ numberOfEmployees }}</td>
                </tr>
                <tr>
                    <th>Uitzetten</th>
                    <td>{{ planning | planningFieldValue: 'uitzetten' }}</td>
                    <th>Speciale mallen</th>
                    <td colspan="3">{{ planning | planningFieldValue: 'mallen' }}</td>
                </tr>
                @if (planning?.planning_files?.length) {
                    <tr>
                        <th>Bijgevoegde tekeningen</th>
                        <td colspan="3">
                            @for (file of planning?.planning_files; track file.id; let last = $last) {
                                - <a class="attachment-link" (click)="openFile(file)">{{ file.name }}</a>
                                @if (!last) {
                                    <br />
                                }
                            }
                        </td>
                    </tr>
                }
            </tbody>
        </table>
    </section>

    <section>
        <table>
            <tbody>
                <tr>
                    <th>Opmerkingen</th>
                </tr>
                <tr>
                    <td [innerHTML]="planning?.comment | nl2br"></td>
                </tr>
            </tbody>
        </table>
    </section>
</div>
